/* eslint-disable */
import React, { useState } from 'react';
import { supabase } from '../supabase';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [mode, setMode] = useState('signin');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async () => {
    setLoading(true);
    setError('');
    setMessage('');

    if (mode === 'signup') {
      if (!firstName || !lastName || !phone) {
        setError('Please fill in all fields.');
        setLoading(false);
        return;
      }
      const { error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            first_name: firstName,
            last_name: lastName,
            phone: phone,
            full_name: `${firstName} ${lastName}`,
          }
        }
      });
      if (error) setError(error.message);
      else setMessage('Account created successfully! You can now sign in.');
    } else if (mode === 'reset') {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: 'https://www.signagepanel.app/reset-password',
      });
      if (error) setError(error.message);
      else setMessage('Password reset link sent — check your email.');
    } else {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) setError(error.message);
    }
    setLoading(false);
  };

  const titles = { signin: 'Sign in to your account', signup: 'Create your account', reset: 'Reset your password' };
  const buttons = { signin: 'Sign In', signup: 'Create Account', reset: 'Send Reset Link' };

  return (
    <div style={{ minHeight: '100vh', background: '#F5EFE6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Helvetica Neue, Arial, sans-serif' }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: '2.5rem', width: 400, border: '1px solid #E0D8CF', boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
        <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#111' }}>Signage<span style={{ color: '#8B1E2D' }}>Panel</span></div>
          <div style={{ fontSize: 13, color: '#777', marginTop: 4 }}>{titles[mode]}</div>
        </div>

        {error && <div style={{ background: '#FDE8E8', color: '#9B2335', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>{error}</div>}
        {message && <div style={{ background: '#E6F0EA', color: '#2D6A4F', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>{message}</div>}

        {mode === 'signup' && (
          <>
            <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
              <div style={{ flex: 1 }}>
                <label style={lbl}>First Name</label>
                <input value={firstName} onChange={e => setFirstName(e.target.value)} placeholder="John" style={inp} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={lbl}>Last Name</label>
                <input value={lastName} onChange={e => setLastName(e.target.value)} placeholder="Smith" style={inp} />
              </div>
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={lbl}>Phone Number</label>
              <input value={phone} onChange={e => setPhone(e.target.value)} placeholder="+44 7700 000000" style={inp} />
            </div>
          </>
        )}

        <div style={{ marginBottom: 14 }}>
          <label style={lbl}>Email</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" style={inp} />
        </div>

        {mode !== 'reset' && (
          <div style={{ marginBottom: mode === 'signin' ? 8 : 20 }}>
            <label style={lbl}>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" onKeyDown={e => e.key === 'Enter' && handleSubmit()} style={inp} />
          </div>
        )}

        {mode === 'signin' && (
          <div style={{ textAlign: 'right', marginBottom: 16 }}>
            <span onClick={() => { setMode('reset'); setError(''); setMessage(''); }} style={{ fontSize: 12, color: '#8B1E2D', cursor: 'pointer' }}>Forgot password?</span>
          </div>
        )}

        <button onClick={handleSubmit} disabled={loading} style={{ width: '100%', padding: '11px', background: '#8B1E2D', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, marginBottom: 16 }}>
          {loading ? 'Please wait...' : buttons[mode]}
        </button>

        <div style={{ textAlign: 'center', fontSize: 13, color: '#777' }}>
          {mode === 'signin' && <>Don't have an account? <span onClick={() => { setMode('signup'); setError(''); setMessage(''); }} style={{ color: '#8B1E2D', cursor: 'pointer', fontWeight: 600 }}>Sign up</span></>}
          {mode === 'signup' && <>Already have an account? <span onClick={() => { setMode('signin'); setError(''); setMessage(''); }} style={{ color: '#8B1E2D', cursor: 'pointer', fontWeight: 600 }}>Sign in</span></>}
          {mode === 'reset' && <span onClick={() => { setMode('signin'); setError(''); setMessage(''); }} style={{ color: '#8B1E2D', cursor: 'pointer', fontWeight: 600 }}>← Back to sign in</span>}
        </div>
      </div>
    </div>
  );
}

const lbl = { fontSize: 12, color: '#555', display: 'block', marginBottom: 5 };
const inp = { width: '100%', padding: '9px 12px', border: '1px solid #E0D8CF', borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box' };